import { useContext, useState, useEffect } from "react";
import { remove } from "../../../../adapters/xhr/api";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import styleListData from "./index.module.css";
import stylesModal from "../../forms/formTypes/Modal.module.css";

import Pagination, {
  PaginationTax,
} from "../../../../shared/pagination/Pagination";
import { useParams } from "react-router-dom";
import { getDeclerationUnitList } from "../../../../adapters/apis/lookups/lookups";
import Modal from "react-modal";
import { ca } from "date-fns/locale";

const ServiceUnitList = ({ onDeleteSuccess }) => {
  Modal.setAppElement("body");

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    setDeclarationRequest,
    setIsUnitInSameBuilding,
    isFormValidCheckForEditList,
    setBackendError,
  } = unifiedTaxDeclarationContext;

  const { id } = useParams();
  const [limit, setLimit] = useState(
    declarationRequest?.service_units?.pagination?.per_page,
  );
  const [showModal, setShowModal] = useState(false);
  const [idToBeDeleted, setIdToBeDeleted] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   handlePageChange(1);
  // }, []);

  const handlePageChange = async (index, newLimit) => {
    try {
      const param = `service_page=${index}&service_per_page=${newLimit || limit}`;
      const response = await getDeclerationUnitList(id, param);

      setDeclarationRequest({
        ...declarationRequest,
        service_units: response?.data?.data?.service_units,
      });
    } catch (error) {
      console.log("لا توجد بيانات متاحة");
    }
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    handlePageChange(1, newLimit);
  };

  const handleShowUnit = (unit) => {
    if (isFormValidCheckForEditList()) {
      setDeclarationRequest((prev) => ({
        ...prev,
        unit,
        isShowOnlyUnit: true,
        isUnitViewMode: true,
      }));
      setIsUnitInSameBuilding(false);
    } else {
      window.scroll(0, 0);
    }
  };

  const handleEditUnit = (unit) => {
    if (isFormValidCheckForEditList()) {
      setDeclarationRequest((prev) => ({
        ...prev,
        unit,
        isUnitEditMode: true,
        isUnitViewMode: false,
        isShowOnlyUnit: true,
      }));
      setIsUnitInSameBuilding(false);
    } else {
      window.scroll(0, 0);
    }
  };

  const handleDeleteUnit = async () => {
    setIsLoading(true);
    setBackendError(null);
    try {
      if (!idToBeDeleted) {
        return;
      }
      const response = await remove(
        `api/declaration-system/declarations/${id}/units/service/${idToBeDeleted}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        },
      );
      setDeclarationRequest({
        ...declarationRequest,
        service_units: response?.data?.data?.service_units,
        units_count: response?.data?.data?.units_count,
      });
      setShowModal(false);
      setIdToBeDeleted(null);
      onDeleteSuccess?.();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setBackendError(
        error?.response?.data?.message || "حدث خطأ أثناء حذف الوحدة",
      );
      setShowModal(false);
      window.scroll(0, 0);
    }
  };

  const serviceUnits = declarationRequest?.service_units;

  const exemptionReasonMap = {
    1: "الأبنية المملوكة للجمعيات المسجلة وفقا للقانون",
    2: "المنظمات العمالية المخصصة لمكاتب إداراتها أو لممارسة الأغراض التي أنشئت من أجلها",
    3: "المؤسسات التعليمية التي لا تهدف إلى الربح",
    4: "المستشفيات التي لا تهدف إلى الربح",
    5: "المستوصفات والملاجئ والمبرات التي لا تهدف إلى الربح",
    6: "لمقار المملوكة للأحزاب السياسية التي تستخدم في الأغراض المخصصة لها",
    7: "المقار المملوكة للنقابات المهنية بشرط أن يتم استخدامها في الأغراض المخصصة لها",
    8: "أبنية مراكز الشباب والرياضة المنشأة وفقاً للقوانين المنظمة لها",
    9: "العقارات المملوكة للجهات الحكومية الأجنبية بشرط المعاملة بالمثل",
    10: "الدور المخصصة لاستخدامها فى مناسبات اجتماعية دون استهداف الربح",
    11: "إعفاء بقانون خاص",
  };

  //example addtress
  const address = {
    region: "القاهرة الكبرى",
    goveronrate: "القاهره",
    city: null,
    district: null,
    policestation: "عابدين",
    neighborhood: "شياخه باب اللوق",
    mogawra: null,
    village: null,
    settlement: null,
    street: "ش مصطفى ابو هيف",
    number: 166,
  };

  const data = serviceUnits?.data?.map((unit) => {
    const districtText =
      unit?.village_id == -1 ? unit?.village_other : unit?.village_text || "";
    const streetText =
      unit?.region_id == -1 ? unit?.region_other : unit?.region_text || "";
    const buildingText =
      unit?.real_estate_id == -1
        ? unit?.real_estate_other
        : unit?.real_estate_code || "";
    const floorText =
      unit?.real_estate_floor_id == -1
        ? unit?.real_estate_floor_other_text
        : unit?.real_estate_floor_text || "";
    const unitText =
      unit?.unit_id == -1 ? unit?.unit_other : unit?.unit_unit_num;
    const isExempt =
      unit?.exempted === 1 ||
      unit?.exempted === true ||
      String(unit?.exempted) === "1";
    const exemptionReasonId = parseInt(unit?.exemption_reason, 10);
    const exemptionReasonTextFromApi = unit?.exemption_reason_text || "";
    const isSpecialLawExemption =
      isExempt &&
      (exemptionReasonId === 11 ||
        exemptionReasonTextFromApi.includes("إعفاء بقانون خاص"));
    const exemptionReasonText =
      unit?.exemption_reason_text ||
      exemptionReasonMap[exemptionReasonId] ||
      "—";
    const propertyAddress = unit?.full_address;

    const renin =
      unit?.buildingProfile?.renin || unit?.manual_renin || "لم يتم تحديده بعد";

    return (
      <tr key={unit?.id}>
        {/* <td data-label="نوع العقار">
          {unit?.property_type_text || "الوحدات الخدمية"}
        </td> */}
        <td data-label="المحافظة">
          {unit?.buildingProfile?.address?.goveronrate ||
            unit?.governorate_text ||
            unit?.manual_governorate_name ||
            ""}
        </td>

        <td data-label=" عنوان العقار">
          {unit?.correct_astrick_colour && (
            <span className={`${unit.correct_astrick_colour} mr-1`}>*</span>
          )}
          {propertyAddress || ""}
        </td>
        <td data-label="الرقم القومي العقاري للمبنى">
          {unit?.correct_astrick_colour && (
            <span className={`${unit.correct_astrick_colour} mr-1`}>*</span>
          )}
          {renin}
        </td>

        {/* <td data-label="المأمورية / القسم">{unit?.district_text || ""}</td>
        <td data-label="منطقة / شياخة">{districtText}</td>
        <td data-label="شارع">{streetText}</td>
        <td data-label="عقار / قطعة">{buildingText}</td> */}
        <td data-label="الدور">{floorText}</td>
        <td data-label="الوحدة">{unit?.unit_number || unitText}</td>
        {/* <td data-label="تم التواصل مع الضرائب العقارية">
          {parseInt(unit?.reta_contact_about_unit) === 1 ? "نعم" : "لا"}
        </td> */}
        <td data-label="كود حساب الوحدة">{unit?.account_code || "—"}</td>
        <td data-label="نوع الإستخدام">
          {unit?.usage_type_text || unit?.usage_type || ""}
        </td>
        <td data-label="المساحة">{unit?.area || "—"}</td>
        <td data-label="نوع الوحدة">{unit?.unit_type_text || "—"}</td>
        <td data-label="نوع النشاط">{unit?.activity_type || ""}</td>
        <td data-label="هل الوحدة معفاه؟">{isExempt ? "نعم" : "لا"}</td>
        <td data-label="سبب الإعفاء">{isExempt ? exemptionReasonText : "—"}</td>
        <td data-label="رقم القانون">
          {isSpecialLawExemption ? unit?.law_number || "—" : "—"}
        </td>
        <td data-label="سنة القانون">
          {isSpecialLawExemption ? unit?.law_year || "—" : "—"}
        </td>
        <td data-label="القيمة السوقية للوحدة">{unit?.market_value || "—"}</td>

        {/* actions */}
        <td data-label="تفاصيل">
          <div
            className={`d-flex gap-2 ${styleListData["action-buttons-small-screen"]}`}
          >
            <div className={`${styleListData["action-buttons"]}`}>
              <button
                className={`${styleListData["btn-view"]}`}
                onClick={() => handleShowUnit(unit)}
              >
                <i className="fa-solid fa-file-lines"></i>
              </button>
              {!declarationRequest?.viewMode && (
                <span className={`${styleListData["divider"]}`}></span>
              )}

              {!declarationRequest?.viewMode && (
                <>
                  <button
                    className={`${styleListData["btn-edit"]}`}
                    onClick={() => handleEditUnit(unit)}
                  >
                    <i className="fa-solid fa-pen-to-square"></i>
                  </button>

                  <span className={`${styleListData["divider"]}`}></span>
                  <button
                    className={`${styleListData["btn-delete"]}`}
                    onClick={() => {
                      setIdToBeDeleted(unit?.id);
                      setShowModal(true);
                    }}
                  >
                    <i className="fa-solid fa-trash-can"></i>
                  </button>
                </>
              )}
            </div>
          </div>
        </td>
      </tr>
    );
  });

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من حذف هذا العقار؟</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteUnit}
              disabled={isLoading}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      {serviceUnits?.data?.length > 0 ? (
        <>
          <div
            className={`${styleListData["table-responsive"]} table-responsive`}
          >
            <table className="table">
              <thead>
                <tr>
                  {/*  {/* <th>نوع العقار</th> */}
                  <th>المحافظة</th>
                  <th>عنوان العقار</th>
                  <th>الرقم القومي العقاري للمبنى</th>
                  {/* <th>رقم العقار/المبنى المتعارف عليه</th> */}
                  {/* <th>المأمورية / القسم</th>
                  <th>منطقة / شياخة</th>
                  <th>شارع</th>
                  <th>عقار / قطعة</th> */}
                  <th>الدور</th>
                  <th>الوحدة</th>
                  {/* <th>تم التواصل مع الضرائب العقارية</th> */}
                  <th>كود حساب الوحدة</th>
                  <th>نوع الإستخدام</th>
                  <th>المساحة</th>
                  <th>نوع الوحدة</th>
                  <th>نوع النشاط</th>
                  <th>هل الوحدة معفاه؟</th>
                  <th>سبب الإعفاء</th>
                  <th>رقم القانون</th>
                  <th>سنة القانون</th>
                  <th>القيمة السوقية للوحدة</th>
                  <th>تفاصيل</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data
                ) : (
                  <tr>
                    <td colSpan={20} className="h5 text-center">
                      لا يوجد وحدات خدمية
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <PaginationTax
            limit={limit}
            count={serviceUnits?.pagination?.total}
            active={serviceUnits?.pagination?.current_page}
            callback={handlePageChange}
            handleLimitChange={handleLimitChange}
          />
        </>
      ) : (
        <h4 className="text-center box-title">لا يوجد وحدات خدمية</h4>
      )}
    </>
  );
};
export default ServiceUnitList;
